'use strict';

var Dispatcher = require('../core/AppDispatcher.jsx');
var Constants = require('../constants/PensionTypeConstants.js');

var PensionTypeActions = {
    selectPensionType: function(fieldId, selectedPensionType, componentId, investmentListAvailable) {
        Dispatcher.dispatch({
            actionType: Constants.ActionTypes.SELECT_PENSION_TYPE,
            fieldId: fieldId,
            value: selectedPensionType,
            componentId: componentId,
            investmentListAvailable: investmentListAvailable
        });
    },

    selectBenefit: function(fieldId, selectedBenefit, componentId) {
        Dispatcher.dispatch({
            actionType: Constants.ActionTypes.SELECT_BENEFIT,
            fieldId: fieldId,
            value: selectedBenefit,
            componentId: componentId
        });
    }
};

module.exports = PensionTypeActions;



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/PensionTypeActions.js